// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"styles_ellipsis__22bU8","ellipsis1":"styles_ellipsis1__3SiUM","ellipsis2":"styles_ellipsis2__273ez","ellipsis3":"styles_ellipsis3__1cuqq"};